// mds-dojo — dojo/dom-class. add/remove/toggle/contains/replace on classList.
// dojo accepts space-separated class strings or arrays.

function toList(classes: string | string[]): string[] {
  if (Array.isArray(classes)) { return classes; }
  return String(classes).split(/\s+/).filter(Boolean);
}

export function contains(node: Element, className: string): boolean {
  return !!node && node.classList.contains(className);
}

export function add(node: Element, classes: string | string[]): void {
  if (!node) { return; }
  for (const c of toList(classes)) { node.classList.add(c); }
}

export function remove(node: Element, classes?: string | string[]): void {
  if (!node) { return; }
  if (classes == null) { node.className = ''; return; }
  for (const c of toList(classes)) { node.classList.remove(c); }
}

export function toggle(node: Element, classes: string | string[], force?: boolean): boolean {
  // dojo semantics: space-separated lists toggle each token.
  if (!node) { return false; }
  const list = toList(classes);
  const add2 = force === undefined ? !(list.length === 1 && contains(node, list[0])) : force;
  for (const c of list) {
    const doAdd = force === undefined ? !node.classList.contains(c) : force;
    if (doAdd) { node.classList.add(c); } else { node.classList.remove(c); }
  }
  return add2;
}

export function replace(node: Element, addCls: string | string[], removeCls?: string | string[]): void {
  remove(node, removeCls);
  add(node, addCls);
}

const domClass = { contains, add, remove, toggle, replace };
export default domClass;
